// The App's possible actions to modify the store.
import { createAction, createStandardAction } from "typesafe-actions";
// Following tutorials:
//  - https://github.com/piotrwitek/typesafe-actions#behold-the-mighty-tutorial
//  - https://github.com/piotrwitek/react-redux-typescript-guide
// Actions
// 1. Define an action here.
// 2. Define how it's resolved in terms of modifying the store, in reducer
export const addItems = createAction("chemix/ADD_ITEM", resolve => {
    return (data) => resolve(data);
});
export const addItemsAtIndices = createAction("chemix/ADD_ITEMS_AT_INDEX", resolve => {
    return (data) => resolve(data);
});
/** Updates the appearance by modifying a single property. */
export const updateAppearance = createAction("chemix/UPDATE_APPEARANCE", resolve => {
    return (id, key, value) => resolve({ id: id, key: key, value: value });
});
/** Updates appearance by modifying a single property of multiple items of the same type. */
export const updateItemsAppearance = createAction("chemix/UPDATE_APPEARANCE_MULTI_ITEMS", resolve => {
    return (key, values) => {
        const idsToValuesMap = {};
        for (const value of values) {
            idsToValuesMap[value.id.id] = value.value;
        }
        return resolve({ key, idsToValuesMap });
    };
});
/**
 * Updates the appearance by modifying multiple properties of a single item. Works on Apparatus only.
 */
export const updateAppearanceProperties = createAction("chemix/UPDATE_APPEARANCE_PROPS", resolve => {
    return (id, props) => resolve({ id, props });
});
/** Updates the appearance of multiple properties of apparatus of the same type. Works on apparatus only. */
export const updateItemsAppearanceProperties = createAction("chemix/UPDATE_APPEARANCE_PROPS_MULTI_ITEMS", resolve => {
    return (ids, props) => resolve({ ids, props });
});
export const removeItems = createAction("chemix/REMOVE_ITEMS", resolve => {
    return (ids) => resolve({ ids });
});
export const removeFromGroup = createAction("chemix/REMOVE_FROM_GROUP", resolve => {
    return (data) => resolve(data);
});
export const addToGroup = createAction("chemix/ADD_TO_GROUP", resolve => {
    return (data) => resolve(data);
});
/**
 * Note this only rotates apparatus, not arrows. It takes in an unsorted
 * dictionary of apparatus ID numbers desired rotation values.
 */
export const setItemsRotation = createAction("chemix/SET_ITEMS_ROTATION", resolve => {
    return (rotations) => resolve({ rotations: rotations });
});
export const generic = createAction("chemix/GENERIC", resolve => {
    return (name, actionFn) => resolve({ name, actionFn });
});
/** Switch the current active tool. */
export const switchTool = createAction("chemix/SWITCH_TOOL", resolve => {
    return (tool) => resolve(tool);
});
/**
 * Erases items and arrows.
 * TODO: This is needed because refs stored in editor canvas
 * are based on ID only but not type. This means the same ID
 * could be reused for a different apparatus type, so the
 * refs are now pointing to old objects.
 */
export const eraseItems = createAction("chemix/CLEAR_ALL", resolve => {
    return () => resolve();
});
// File-related operations.
/** Replace current state with given document. */
export const replace = createAction("chemix/REPLACE", resolve => {
    return (diagram, isTemplate) => resolve({ diagram, isTemplate });
});
/** Sets cloud information about current diagram, or resets it to null. */
export const setCloudDiagram = createStandardAction("chemix/SET_CLOUD_DIAGRAM")();
/** Updates the current theme thickness. */
export const setThemeStrokeThickness = createStandardAction("chemix/SET_THEME_STROKE")();
// ChemMark config
export const updateChemMarkConfigStateOfMatterStyle = createStandardAction("chemix/UPDATE_CHEM_MARK_CONFIG")();
/** Resets state completely, should only be used for tests. */
export const _TESTONLY_resetState = createAction("chemix/TEST_ONLY_RESET_STATE", resolve => {
    return (state) => resolve(state);
});
// Auth actions.
export const logIn = createAction("user/LOG_IN", resolve => {
    return (data) => resolve(data);
});
export const logOut = createAction("user/LOG_OUT", resolve => {
    return () => resolve();
});
